import { RouteObject } from "react-router-dom";
import { STAFF_ARCHIVE_ROUTE, PERFORMERS_ROUTE, PERFORMERS_ARCHIVE_ROUTE } from './routes';
import { ADMIN_CREATE_ROUTE, ADMIN_LESSONS_ROUTE, ADMIN_ROUTE, ADMIN_TRANSACTIONS_ROUTE, ADMINS_ROUTE,
    ASSISTANT_CREATE_ROUTE, ASSISTANT_ROUTE, ASSISTANTS_ROUTE, AUTH_ROUTE, EVENTS_ROUTE, FINANCE_DOCUMENTS_ROUTE, FINANCE_ROUTE, HOME_ROUTE,
    IDM_CREATE_ROUTE, IDM_FEATURES_ROUTE, IDM_ROLES_ROUTE, IDM_ROUTE, IDM_STAFF_ROUTE, LEGAL_INFO_ROUTE, LOGIN_ROUTE,
    REGISTRATION_ROUTE, STAFF_DOCUMENTS_ROUTE, STAFF_HISTORY_ROUTE, STAFF_IDM_ROUTE, MY_ROUTE, STAFF_PAYMENT_DETAILS_ROUTE, STAFF_ROUTE, STAFF_UPDATE_ROUTE, STAFF_USER_ROUTE, STUDENT_CREATE_ROUTE,
    STATISTICS_ROUTE, STUDENT_HISTORY_ROUTE, STUDENT_PAYMENT_ROUTE, STUDENT_ROUTE, STUDENT_TAGS_ROUTE, STUDENT_UPDATE_ROUTE, STUDENT_WALLET_HISTORY_ROUTE, STUDENTS_ARCHIVE_ROUTE,
    STUDENTS_ROUTE, TUTOR_LESSONS_ROUTE, TUTOR_ACCRUALS_ROUTE, TUTOR_FINANCE_ROUTE, THANK_YOU_ROUTE,
    WORK_TGS_ROUTE, CALENDAR_ROUTE, CALENDAR_SHIFT_ROUTE, TEAM_ROUTE, TEAMS_ROUTE} from "./routes";
import App from "../../App";
import HomePage from "../../pages/home/HomePage";
import AuthPage from "../../pages/auth/auth/AuthPage";
import StudentsPage from "../../pages/students/students/Students";
import StudentChangePage from "../../pages/studentChange/StudentChange";
import StudentPage from "../../pages/student/Student";
import FinancePage from "../../pages/finance/Finance";
import AdminsPage from "../../pages/admins/Admins";
import AdminPage from "../../pages/admin/Admin";
import AdminChangePage from "../../pages/adminChange/AdminChange";
import AuthLayoutPage from "../../pages/auth/layout/AuthLayout";
import AuthVerifyPage from "../../pages/auth/verify/AuthVerifyPage";
import NotFoundPage from "../../pages/notFound/NotFound";
import TutorLessonsPage from "../../pages/tutorLessons/TutorLessons";
import AdminTransactionsPage from "../../pages/adminTransactions/AdminTransactions";
import AdminLessonsPage from "../../pages/adminLessons/AdminLessons";
import StudentsArchivePage from "../../pages/students/archive/StudentsArchive";
import AssistantsPage from "../../pages/assistants/Assistants";
import AssistantCreatePage from "../../pages/assistantCreate/AssistantCreate";
import AssistantPage from "../../pages/assistant/Assistant";
import PaymentPage from "../../pages/payment/Payment";
import StudentsLayoutPage from "../../pages/students/layout/StudentsLayout";
import TutorAccrualsPage from "../../pages/tutorAccruals/TutorAccruals";
import TutorFinancePage from "../../pages/tutorFinance/TutorFinance";
import SpasiboPage from "../../pages/spasibo/Spasibo";
import StudentTagsPage from "../../pages/studentTags/StudentTags";
import IdmPage from "../../pages/idm/Idm";
import IdmCreatePage from "../../pages/idmCreate/IdmCreate";
import IdmFeaturesPage from "../../pages/idmFeatures/IdmFeatures";
import IdmRolesPage from "../../pages/idmRoles/IdmRoles";
import WorkTgsPage from "../../pages/workTgs/WorkTgs";
import TeamsPage from "../../pages/teams/Teams";
import CalendarPage from "../../pages/calendar/month/Calendar";
import CalendarLayoutPage from "../../pages/calendar/layout/CalendarLayout";
import CalendarLessonsLayoutPage from "../../pages/calendar/lessonsLayout/CalendarLessonsLayout";
import CalendarDayPage from "../../pages/calendar/day/CalendarDay";
import CalendarTrialPage from "../../pages/calendar/trial/CalendarTrial";
import CalendarTrialDayPage from "../../pages/calendar/trialDay/CalendarTrialDay";
import CalendarShiftPage from "../../pages/calendar/shift/CalendarShift";
import CalendarShiftDayPage from "../../pages/calendar/shiftDay/CalendarShiftDay";
import CalendarShiftLayoutPage from "../../pages/calendar/shiftLayout/CalendarShiftLayout";
import MyPage from "../../pages/my/My";
import StaffPage from "../../pages/staff/Staff";
import StaffUpdatePage from "../../pages/staffUpdate/StaffUpdate";
import StaffDocumentsPage from '../../pages/staffDocuments/StaffDocuments';
import EventsPage from "../../pages/events/Events";
import StatisticsPage from "../../pages/statistics/Statistics";
import LegalInfoPage from "../../pages/legalInfo/LegalInfo";


export const Router: RouteObject[] = [
    {
        path: HOME_ROUTE.path,
        Component: App,
        ErrorBoundary: NotFoundPage,
        children: [
            {
                path: HOME_ROUTE.path,
                Component: HomePage
            },
            {
                path: CALENDAR_ROUTE.path,
                Component: CalendarLayoutPage,
                children: [
                    {
                        Component: CalendarLessonsLayoutPage,
                        children: [
                            {
                                index: true,
                                Component: CalendarPage,
                            },
                            {
                                path: 'trial',
                                Component: CalendarTrialPage,
                            },
                            {
                                path: 'trial/day/:date',
                                Component: CalendarTrialDayPage,
                            },
                            {
                                path: 'trial/day/:date/lesson/:lessonId',
                                Component: CalendarTrialDayPage,
                            },
                            {
                                path: 'day/:date',
                                Component: CalendarDayPage,
                            },
                            {
                                path: 'day/:date/lesson/:lessonId',
                                Component: CalendarDayPage,
                            },
                        ],
                    },
                ]
            },
            {
                path: CALENDAR_SHIFT_ROUTE.path,
                Component: CalendarShiftLayoutPage,
                children: [
                    {
                        index: true,
                        Component: CalendarShiftPage,
                    },
                    {
                        path: 'day/:date',
                        Component: CalendarShiftDayPage,
                    },
                ],
            },
            {
                path: EVENTS_ROUTE.path,
                Component: EventsPage,
            },
            {
                path: STATISTICS_ROUTE.path,
                Component: StatisticsPage,
            },
            {
                path: LEGAL_INFO_ROUTE.path,
                Component: LegalInfoPage,
            },
            {
                path: MY_ROUTE.path,
                Component: MyPage
            },
            {
                path: AUTH_ROUTE.path,
                Component: AuthLayoutPage,
                children: [
                    {
                        path: AUTH_ROUTE.path,
                        Component: AuthPage,
                    },
                    {
                        path: LOGIN_ROUTE.path,
                        Component: AuthVerifyPage
                    },
                    {
                        path: REGISTRATION_ROUTE.path,
                        Component: AuthVerifyPage
                    }
                ]
            },
            {
                path: STUDENTS_ROUTE.path,
                Component: StudentsLayoutPage,
                children: [
                    {
                        path: STUDENTS_ARCHIVE_ROUTE.path,
                        Component: StudentsArchivePage
                    },
                    {
                        path: STUDENTS_ROUTE.path,
                        Component: StudentsPage
                    },
                ]
            },
            {
                path: STUDENT_CREATE_ROUTE.path,
                Component: StudentChangePage
            },
            {
                path: STUDENT_UPDATE_ROUTE.path,
                Component: StudentChangePage
            },
            {
                path: STUDENT_ROUTE.path,
                Component: StudentPage
            },
            {
                path: STUDENT_HISTORY_ROUTE.path,
                Component: StudentPage
            },
            {
                path: STUDENT_WALLET_HISTORY_ROUTE.path,
                Component: StudentPage
            },
            {
                path: STUDENT_TAGS_ROUTE.path,
                Component: StudentTagsPage
            },
            {
                path: WORK_TGS_ROUTE.path,
                Component: WorkTgsPage
            },
            {
                path: TEAMS_ROUTE.path,
                Component: TeamsPage
            },
            {
                path: TEAM_ROUTE.path,
                Component: TeamsPage
            },
            {
                path: STAFF_DOCUMENTS_ROUTE.path,
                Component: StaffDocumentsPage
            },
            {
                path: STAFF_ROUTE.path,
                Component: StaffPage
            },
            ...[STAFF_ARCHIVE_ROUTE.path, PERFORMERS_ROUTE.path, PERFORMERS_ARCHIVE_ROUTE.path,
                ...[STAFF_USER_ROUTE, STAFF_IDM_ROUTE, STAFF_PAYMENT_DETAILS_ROUTE, STAFF_HISTORY_ROUTE]
                    .map(route => route.path.replace(STAFF_ROUTE.path, PERFORMERS_ROUTE.path))
            ].map(path => ({path, Component: StaffPage})),
            {
                path: STAFF_UPDATE_ROUTE.path.replace(STAFF_ROUTE.path, PERFORMERS_ROUTE.path),
                Component: StaffUpdatePage
            },
            {
                path: STAFF_USER_ROUTE.path,
                Component: StaffPage
            },
            {
                path: STAFF_IDM_ROUTE.path,
                Component: StaffPage
            },
            {
                path: STAFF_PAYMENT_DETAILS_ROUTE.path,
                Component: StaffPage
            },
            {
                path: STAFF_HISTORY_ROUTE.path,
                Component: StaffPage
            },
            {
                path: STAFF_UPDATE_ROUTE.path,
                Component: StaffUpdatePage
            },
            {
                path: IDM_ROUTE.path,
                Component: IdmPage
            },
            {
                path: IDM_CREATE_ROUTE.path,
                Component: IdmCreatePage
            },
            {
                path: IDM_ROLES_ROUTE.path,
                Component: IdmRolesPage
            },
            {
                path: IDM_FEATURES_ROUTE.path,
                Component: IdmFeaturesPage
            },
            {
                path: IDM_STAFF_ROUTE.path,
                Component: IdmPage
            },
            {
                path: TUTOR_FINANCE_ROUTE.path,
                Component: TutorFinancePage
            },
            {
                path: TUTOR_ACCRUALS_ROUTE.path,
                Component: TutorAccrualsPage
            },
            {
                path: FINANCE_DOCUMENTS_ROUTE.path,
                Component: FinancePage
            },
            {
                path: FINANCE_ROUTE.path,
                Component: FinancePage
            },
            {
                path: ADMINS_ROUTE.path,
                Component: AdminsPage
            },
            {
                path: ADMIN_ROUTE.path,
                Component: AdminPage
            },
            {
                path: ADMIN_CREATE_ROUTE.path,
                Component: AdminChangePage
            },
            {
                path: TUTOR_LESSONS_ROUTE.path,
                Component: TutorLessonsPage
            },
            {
                path: ADMIN_TRANSACTIONS_ROUTE.path,
                Component: AdminTransactionsPage
            },
            {
                path: ADMIN_LESSONS_ROUTE.path,
                Component: AdminLessonsPage
            },
            {
                path: ASSISTANTS_ROUTE.path,
                Component: AssistantsPage
            },
            {
                path: ASSISTANT_CREATE_ROUTE.path,
                Component: AssistantCreatePage
            },
            {
                path: ASSISTANT_ROUTE.path,
                Component: AssistantPage
            },
            {
                path: STUDENT_PAYMENT_ROUTE.path,
                Component: PaymentPage
            },
            {
                path: THANK_YOU_ROUTE.path,
                Component: SpasiboPage
            }
        ]
    }
]
